export class AssignVenuesMenuModel {
  public venueMenuId: string;
  public venueIds: Array<string>;
}
